import { render, staticRenderFns } from "./received.vue?vue&type=template&id=1a4ff315&scoped=true&"
import script from "./received.vue?vue&type=script&lang=js&"
export * from "./received.vue?vue&type=script&lang=js&"
import style0 from "./received.vue?vue&type=style&index=0&id=1a4ff315&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4ff315",
  null
  
)

export default component.exports